import { Router } from '@angular/router'

/** Безопасный return_url: не допускает /error и раскручивает вложенные return_url. */
export function sanitizeReturnUrl(value: string | null): string {
  if (!value) {
    return '/'
  }
  let trimmed = value.trim()

  while (trimmed.startsWith('/error')) {
    const queryStart = trimmed.indexOf('?')
    if (queryStart === -1) {
      return '/'
    }
    const nested = new URLSearchParams(trimmed.slice(queryStart + 1)).get('return_url')
    if (!nested) {
      return '/'
    }
    trimmed = nested
  }

  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) {
    return '/'
  }
  return trimmed
}

/** URL, на который пользователь пытался перейти (для страницы ошибки и «Повторить»). */
function serializeAttemptedNavigation(router: Router): string {
  const nav = router.currentNavigation()
  const tree = nav?.extractedUrl ?? nav?.initialUrl
  if (tree) {
    return sanitizeReturnUrl(router.serializeUrl(tree))
  }
  const current = router.url
  return sanitizeReturnUrl(current && current !== '' ? current : '/main')
}

export function createLoadErrorUrlTree(router: Router) {
  return router.createUrlTree(['/error'], {
    queryParams: { 'return_url': serializeAttemptedNavigation(router) },
  })
}
